<template>
	<div>
		<div id="awards" class="tabcontent" style="display: block !important;">
			<div class="lightBubble absolute">
				<div class="bubbleImage"></div>
				<p class="typewriter">
					<vue-typewriter
						:text="'S svojo aktivnostjo v Episcenterklubu ste zbrali dovolj točk. Unovčite jih lahko za naslednje nagrade.'"
						v-if="getAvailablePoints(points.transactions) > 999">
					</vue-typewriter>
					<vue-typewriter
						:text="'Za izbiro nagrad potrebujete vsaj 1.000 točk.'"
						v-else>
					</vue-typewriter>
				</p>
				<span class="typewriter-output"></span>
			</div>
			<div class="wp710">

				<div v-if="getUsePointsProject(projects) && getAvailablePoints(points.transactions) > 999">
					<a class="boxesLink" :href="getUsePointsProject(projects)" target="_blank" v-for="award in awards" :key="award.id">
						<div class="box flex gift">
							<div class="boxContent">
								<div class="card flex">
									<div class="col1_3">
										<div class="aroundImage">
											<img :src="getImgUrl(award.image)" :alt="award.title" />
											<div class="imageIcon pink flex" v-if="award.type === 'card'">
												<span class="icon warpit_icon_your-card"></span>
											</div>
											<div class="imageIcon green-blue flex" v-else-if="award.type === 'product'">
												<span class="icon warpit_icon_package"></span>
											</div>
											<div class="imageIcon pink flex" v-else-if="award.type === 'gift'">
												<span class="icon warpit_icon_gift"></span>
											</div>
										</div>
									</div>
									<div class="col2_3">
										<h2>
											<span>{{ award.title }}</span>
										</h2>
										<p>{{ award.description }}</p>
										<div class="points">
											<span>{{ formatNumber(award.points) }}</span>
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M12 0C10.3438 0 8.78906 0.3125 7.33594 0.9375C5.86719 1.5625 4.58594 2.42188 3.49219 3.51562C2.41406 4.59375 1.5625 5.86719 0.9375 7.33594C0.3125 8.78906 0 10.3438 0 12C0 13.6562 0.3125 15.2109 0.9375 16.6641C1.5625 18.1328 2.41406 19.4141 3.49219 20.5078C4.58594 21.5859 5.86719 22.4375 7.33594 23.0625C8.78906 23.6875 10.3438 24 12 24C13.6562 24 15.2109 23.6875 16.6641 23.0625C18.1328 22.4375 19.4062 21.5859 20.4844 20.5078C21.5781 19.4141 22.4375 18.1328 23.0625 16.6641C23.6875 15.2109 24 13.6562 24 12C24 10.3438 23.6875 8.78906 23.0625 7.33594C22.4375 5.86719 21.5781 4.59375 20.4844 3.51562C19.4062 2.42188 18.1328 1.5625 16.6641 0.9375C15.2109 0.3125 13.6562 0 12 0ZM12 22.5C10.5469 22.5 9.1875 22.2266 7.92188 21.6797C6.64062 21.1328 5.52344 20.3828 4.57031 19.4297C3.61719 18.4766 2.86719 17.3594 2.32031 16.0781C1.77344 14.8125 1.5 13.4531 1.5 12C1.5 10.5469 1.77344 9.1875 2.32031 7.92188C2.86719 6.64062 3.61719 5.52344 4.57031 4.57031C5.52344 3.61719 6.64062 2.86719 7.92188 2.32031C9.1875 1.77344 10.5469 1.5 12 1.5C13.4531 1.5 14.8125 1.77344 16.0781 2.32031C17.3594 2.86719 18.4766 3.61719 19.4297 4.57031C20.3828 5.52344 21.1328 6.64062 21.6797 7.92188C22.2266 9.1875 22.5 10.5469 22.5 12C22.5 13.4531 22.2266 14.8125 21.6797 16.0781C21.1328 17.3594 20.3828 18.4766 19.4297 19.4297C18.4766 20.3828 17.3594 21.1328 16.0781 21.6797C14.8125 22.2266 13.4531 22.5 12 22.5ZM12 19.5C11.8594 19.5 11.7344 19.4766 11.625 19.4297C11.5312 19.3672 11.4531 19.2891 11.3906 19.1953H11.3672C10.8984 18.5703 10.3984 17.9844 9.86719 17.4375C9.35156 16.8906 8.80469 16.3828 8.22656 15.9141L8.17969 15.8906C7.24219 15.0781 6.42188 14.2656 5.71875 13.4531C5.03125 12.625 4.6875 11.5312 4.6875 10.1719C4.70312 9.01562 5.11719 8.03906 5.92969 7.24219C6.75781 6.42969 7.74219 6.02344 8.88281 6.02344C9.44531 6.02344 9.96875 6.125 10.4531 6.32812C10.9531 6.53125 11.3906 6.8125 11.7656 7.17188L11.9766 7.35938L12.1875 7.17188C12.5625 6.8125 13 6.53125 13.5 6.32812C14 6.125 14.5312 6.02344 15.0938 6.02344C16.2344 6.02344 17.2109 6.42969 18.0234 7.24219C18.8516 8.03906 19.2734 9.00781 19.2891 10.1484V10.1719C19.2891 11.4531 18.9219 12.5234 18.1875 13.3828C17.4531 14.2422 16.6641 15.0469 15.8203 15.7969C15.2109 16.2812 14.6406 16.8047 14.1094 17.3672C13.5938 17.9141 13.1094 18.4922 12.6562 19.1016L12.6328 19.1484C12.6172 19.1641 12.6016 19.1797 12.5859 19.1953C12.5859 19.2109 12.5781 19.2188 12.5625 19.2188C12.5 19.3125 12.4141 19.3828 12.3047 19.4297C12.2109 19.4766 12.1094 19.5 12 19.5ZM8.90625 7.5C8.90625 7.5 8.89844 7.5 8.88281 7.5C8.14844 7.5 7.51562 7.75781 6.98438 8.27344C6.46875 8.78906 6.21094 9.42188 6.21094 10.1719C6.21094 11.1719 6.48438 12 7.03125 12.6562C7.59375 13.3125 8.32031 14.0078 9.21094 14.7422C9.71094 15.1797 10.1875 15.625 10.6406 16.0781C11.1094 16.5312 11.5547 17 11.9766 17.4844L12 17.5078C12.4375 16.9922 12.8906 16.5 13.3594 16.0312C13.8281 15.5625 14.3125 15.1172 14.8125 14.6953L14.8594 14.6719C15.6406 13.9688 16.3281 13.2812 16.9219 12.6094C17.5156 11.9375 17.8125 11.125 17.8125 10.1719C17.7969 9.42188 17.5234 8.78906 16.9922 8.27344C16.4766 7.75781 15.8438 7.5 15.0938 7.5C14.7344 7.5 14.3906 7.57031 14.0625 7.71094C13.75 7.83594 13.4766 8.01562 13.2422 8.25L12.4922 8.92969C12.4297 8.99219 12.3516 9.03906 12.2578 9.07031C12.1641 9.10156 12.0703 9.11719 11.9766 9.11719C11.8828 9.11719 11.7891 9.10156 11.6953 9.07031C11.6172 9.03906 11.5391 8.99219 11.4609 8.92969L10.7109 8.25C10.4766 8.03125 10.2031 7.85156 9.89062 7.71094C9.57812 7.57031 9.25 7.5 8.90625 7.5Z" fill="#7D7D7D"/>
											</svg>
										</div>
									</div>
								</div>
							</div>
						</div>
					</a>
				</div>
				<div v-else>
					<div class="boxesLink" v-for="award in awards" :key="award.id">
						<div class="box flex gift">
							<div class="boxContent">
								<div class="card flex">
									<div class="col1_3">
										<div class="aroundImage">
											<img :src="getImgUrl(award.image)" :alt="award.title" />
											<div class="imageIcon pink flex" v-if="award.type === 'card'">
												<span class="icon warpit_icon_your-card"></span>
											</div>
											<div class="imageIcon green-blue flex" v-else-if="award.type === 'product'">
												<span class="icon warpit_icon_package"></span>
											</div>
											<div class="imageIcon pink flex" v-else-if="award.type === 'gift'">
												<span class="icon warpit_icon_gift"></span>
											</div>
										</div>
									</div>
									<div class="col2_3">
										<h2>
											<span>{{ award.title }}</span>
										</h2>
										<p>{{ award.description }}</p>
										<div class="points">
											<span>{{ formatNumber(award.points) }}</span>
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M12 0C10.3438 0 8.78906 0.3125 7.33594 0.9375C5.86719 1.5625 4.58594 2.42188 3.49219 3.51562C2.41406 4.59375 1.5625 5.86719 0.9375 7.33594C0.3125 8.78906 0 10.3438 0 12C0 13.6562 0.3125 15.2109 0.9375 16.6641C1.5625 18.1328 2.41406 19.4141 3.49219 20.5078C4.58594 21.5859 5.86719 22.4375 7.33594 23.0625C8.78906 23.6875 10.3438 24 12 24C13.6562 24 15.2109 23.6875 16.6641 23.0625C18.1328 22.4375 19.4062 21.5859 20.4844 20.5078C21.5781 19.4141 22.4375 18.1328 23.0625 16.6641C23.6875 15.2109 24 13.6562 24 12C24 10.3438 23.6875 8.78906 23.0625 7.33594C22.4375 5.86719 21.5781 4.59375 20.4844 3.51562C19.4062 2.42188 18.1328 1.5625 16.6641 0.9375C15.2109 0.3125 13.6562 0 12 0ZM12 22.5C10.5469 22.5 9.1875 22.2266 7.92188 21.6797C6.64062 21.1328 5.52344 20.3828 4.57031 19.4297C3.61719 18.4766 2.86719 17.3594 2.32031 16.0781C1.77344 14.8125 1.5 13.4531 1.5 12C1.5 10.5469 1.77344 9.1875 2.32031 7.92188C2.86719 6.64062 3.61719 5.52344 4.57031 4.57031C5.52344 3.61719 6.64062 2.86719 7.92188 2.32031C9.1875 1.77344 10.5469 1.5 12 1.5C13.4531 1.5 14.8125 1.77344 16.0781 2.32031C17.3594 2.86719 18.4766 3.61719 19.4297 4.57031C20.3828 5.52344 21.1328 6.64062 21.6797 7.92188C22.2266 9.1875 22.5 10.5469 22.5 12C22.5 13.4531 22.2266 14.8125 21.6797 16.0781C21.1328 17.3594 20.3828 18.4766 19.4297 19.4297C18.4766 20.3828 17.3594 21.1328 16.0781 21.6797C14.8125 22.2266 13.4531 22.5 12 22.5ZM12 19.5C11.8594 19.5 11.7344 19.4766 11.625 19.4297C11.5312 19.3672 11.4531 19.2891 11.3906 19.1953H11.3672C10.8984 18.5703 10.3984 17.9844 9.86719 17.4375C9.35156 16.8906 8.80469 16.3828 8.22656 15.9141L8.17969 15.8906C7.24219 15.0781 6.42188 14.2656 5.71875 13.4531C5.03125 12.625 4.6875 11.5312 4.6875 10.1719C4.70312 9.01562 5.11719 8.03906 5.92969 7.24219C6.75781 6.42969 7.74219 6.02344 8.88281 6.02344C9.44531 6.02344 9.96875 6.125 10.4531 6.32812C10.9531 6.53125 11.3906 6.8125 11.7656 7.17188L11.9766 7.35938L12.1875 7.17188C12.5625 6.8125 13 6.53125 13.5 6.32812C14 6.125 14.5312 6.02344 15.0938 6.02344C16.2344 6.02344 17.2109 6.42969 18.0234 7.24219C18.8516 8.03906 19.2734 9.00781 19.2891 10.1484V10.1719C19.2891 11.4531 18.9219 12.5234 18.1875 13.3828C17.4531 14.2422 16.6641 15.0469 15.8203 15.7969C15.2109 16.2812 14.6406 16.8047 14.1094 17.3672C13.5938 17.9141 13.1094 18.4922 12.6562 19.1016L12.6328 19.1484C12.6172 19.1641 12.6016 19.1797 12.5859 19.1953C12.5859 19.2109 12.5781 19.2188 12.5625 19.2188C12.5 19.3125 12.4141 19.3828 12.3047 19.4297C12.2109 19.4766 12.1094 19.5 12 19.5ZM8.90625 7.5C8.90625 7.5 8.89844 7.5 8.88281 7.5C8.14844 7.5 7.51562 7.75781 6.98438 8.27344C6.46875 8.78906 6.21094 9.42188 6.21094 10.1719C6.21094 11.1719 6.48438 12 7.03125 12.6562C7.59375 13.3125 8.32031 14.0078 9.21094 14.7422C9.71094 15.1797 10.1875 15.625 10.6406 16.0781C11.1094 16.5312 11.5547 17 11.9766 17.4844L12 17.5078C12.4375 16.9922 12.8906 16.5 13.3594 16.0312C13.8281 15.5625 14.3125 15.1172 14.8125 14.6953L14.8594 14.6719C15.6406 13.9688 16.3281 13.2812 16.9219 12.6094C17.5156 11.9375 17.8125 11.125 17.8125 10.1719C17.7969 9.42188 17.5234 8.78906 16.9922 8.27344C16.4766 7.75781 15.8438 7.5 15.0938 7.5C14.7344 7.5 14.3906 7.57031 14.0625 7.71094C13.75 7.83594 13.4766 8.01562 13.2422 8.25L12.4922 8.92969C12.4297 8.99219 12.3516 9.03906 12.2578 9.07031C12.1641 9.10156 12.0703 9.11719 11.9766 9.11719C11.8828 9.11719 11.7891 9.10156 11.6953 9.07031C11.6172 9.03906 11.5391 8.99219 11.4609 8.92969L10.7109 8.25C10.4766 8.03125 10.2031 7.85156 9.89062 7.71094C9.57812 7.57031 9.25 7.5 8.90625 7.5Z" fill="#7D7D7D"/>
											</svg>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>

		<div class="noSurvey wp470" v-if="!awards">
			<img src="@/assets/images/emptyCart.svg">
			<h4>{{ $t("store.main_text1") }}</h4><br>
			<p>{{ $t("store.main_text2") }}</p>
		</div>
	</div>
</template>

<script>
import { formatNumber, getAvailablePoints } from '@/helpers.js';
import VueTypewriter from "@/components/VueTypewriter";

export default {
	data() {
		return {
			notCompleted: true,
			awards: [
				{ id: 1, title: 'Srečka za nagradno žrebanje izbrane trgovine', description: 'Žreb petih srečnežev, ki bodo prejeli darilno kartico izbrane trgovine v vrednosti 40 EUR.', points: 500, type: 'card', image: 'award-1' },
				{ id: 2, title: 'Episcenterklub USB ključek', description: 'Varno shranjujte svoje datoteke na Episcenterklub USB ključku, z 32 GB spomina.', points: 1000, type: 'product', image: 'award-2' },
				{ id: 3, title: 'Kopalna brisača', description: 'Naročite mehko in kakovostno kopalno brisačo, s katero boste lahko v poletnih dneh udobno ležali na plaži.', points: 2500, type: 'product', image: 'award-3' },
			]
		};
	},
	update(){
		this.points();
	},
	computed: {
		projects() {
			return this.$store.getters["user/projects"];
		},
		points() {
			return this.$store.getters["user/points"]
		},
	},
	components: {
		VueTypewriter,
	},
	mounted() {},
	methods: {
		formatNumber,
		getAvailablePoints,
		getImgUrl(image) {
			var images = require.context('@/assets/images/awards/', false, /\.jpg$/)
			return images('./' + image + ".jpg")
		},
		getUsePointsProject(projects){
			const usePointsProject = projects.find(project => 
				project.qStatus != '1' && 
				Array.isArray(project.custom_attributes) && 
				project.custom_attributes.some(attr => attr.value === "usepoints")
			);

			return usePointsProject ? usePointsProject.url : null;
		},
	},
};
</script>
